/* eslint-disable jira/filename-case */
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { USER_PROPERTY_BY_STATE_KEY } from './cardCoversSpotlight.constants.tsx';
import type {
	State,
	Props,
	GlobalFieldsTourSteps,
	ProjectFieldsTourSteps,
	CollectionsTourSteps,
	PrioritizationViewTourSteps,
} from './GlobalFieldsTourSteps.types.tsx';
import { setCollectionsTourSpotlightStep } from './setCollectionsTourSpotlightStep.tsx';
import {
	loadCollectionsTourDismissed,
	setCollectionsTourDismissed,
} from './loadCollectionsTourDismissed.tsx';
import {
	loadCrossProjectViewFieldsDismissed,
	setCrossProjectViewFieldsDismissed,
} from './loadCrossProjectViewFieldsDismissed.tsx';
import {
	loadRoadmapIntroductionDismissed,
	loadRoadmapIntroductionPrerequisiteDismissalsMet,
	setRoadmapIntroductionDismissed,
} from './setRoadmapIntroductionDismissed.tsx';
import {
	loadGoToProjectSpotlightDismissed,
	setGoToProjectSpotlightDismissed,
} from './loadGoToProjectSpotlightDismissed.tsx';
import { setGlobalFieldsTourSpotlightStep } from './setGlobalFieldsTourSpotlightStep.tsx';
import {
	loadGlobalFieldsTourDismissed,
	setGlobalFieldsTourDismissed,
} from './setGlobalFieldsTourDismissed.tsx';
import {
	loadExploreSectionMessageDismissed,
	setExploreSectionMessageDismissed,
} from './setExploreSectionMessageDismissed.tsx';
import {
	loadProjectFieldsPageViewed,
	setProjectFieldsPageViewed,
} from './setProjectFieldsPageViewed.tsx';
import {
	loadSeenPulsatingFieldsButton,
	setSeenPulsatingFieldsButton,
} from './setSeenPulsatingFieldsButton.tsx';
import { setProjectFieldsTourSpotlightStep } from './setProjectFieldsTourSpotlightStep.tsx';
import {
	loadProjectFieldsTourDismissed,
	setProjectFieldsTourDismissed,
} from './setProjectFieldsTourDismissed.tsx';
import {
	loadTimelineSectionMessageDismissed,
	setTimelineSectionMessageDismissed,
} from './setTimelineSectionMessageDismissed.tsx';
import { loadGlobalViewsSectionMessageDismissed } from './loadGlobalViewsSectionMessageDismissed.tsx';
import { setGlobalViewsSectionMessageDismissed } from './setGlobalViewsSectionMessageDismissed.tsx';
import {
	loadWeeklyModeSpotlightSeen,
	setWeeklyModeSpotlightSeen,
} from './loadWeeklyModeSpotlightSeen.tsx';
import {
	loadConnectionsSpotlightSeen,
	setConnectionsSpotlightSeen,
} from './loadConnectionsSpotlightSeen.tsx';
import {
	loadAllViewsSpotlightDismissed,
	setAllViewsSpotlightDismissed,
} from './setAllViewsSpotlightDismissed.tsx';

import {
	loadPrioritizationViewTourDismissed,
	setPrioritizationViewTourDismissed,
	setPrioritizationViewTourSpotlightStep,
} from './loadPrioritizationViewTourDismissed.tsx';

import {
	loadRoadmapViewSpotlightDismissed,
	setRoadmapViewSpotlightDismissed,
	loadRoadmapColumnConfigSpotlightDismissed,
	setRoadmapColumnConfigSpotlightDismissed,
} from './loadRoadmapViewSpotlightDismissed.tsx';
import {
	loadPremiumLastVisit,
	loadPremiumModalDismissed,
	setPremiumLastVisit,
	setPremiumModalDismissed,
	unlockOnboardingFlow,
} from './setPremiumLastVisit.tsx';
import { loadProductUsageStartTimestamp } from './loadProductUsageStartTimestamp.tsx';
import {
	loadCustomDatesCustomizeSpotlightDismissed,
	setCustomDatesCustomizeSpotlightDismissed,
} from './loadCustomDatesCustomizeSpotlightDismissed.tsx';
import { loadImportState, setSuccessNotificationViewed } from './loadImportState.tsx';
import {
	loadUnifiedShareDialogSpotlightState,
	setUnifiedShareDialogSpotlightDismissed,
} from './setUnifiedShareDialogSpotlightDismissed.tsx';
import {
	loadTreeViewOnboardingSpotlightDismissed,
	setTreeViewOnboardingSpotlightDismissed,
} from './loadTreeViewOnboardingSpotlightDismissed.tsx';
import { loadCardCoverSpotlightState } from './loadCardCoverSpotlightState.tsx';
import { setCardCoverSpotlightDismissed } from './setCardCoverSpotlightDismissed.tsx';
import {
	loadStartWithTemplateSpotlightDismissed,
	setStartWithTemplateSpotlightDismissed,
} from './loadStartWithTemplateSpotlightDismissed.tsx';
import {
	loadJqlFiltersSpotlightDismissed,
	setJqlFiltersSpotlightDismissed,
} from './loadJqlFiltersSpotlightDismissed.tsx';

export type Actions = {
	loadProductUsageStartTimestamp: () => Action<State, Props, Promise<string | undefined>>;
	loadGoToProjectSpotlightDismissed: () => Action<State, Props>;
	setGoToProjectSpotlightDismissed: () => Action<State, Props>;
	setGlobalFieldsTourSpotlightStep: (step: GlobalFieldsTourSteps | null) => Action<State>;
	loadGlobalFieldsTourDismissed: () => Action<State, Props>;
	setGlobalFieldsTourDismissed: () => Action<State, Props>;
	loadExploreSectionMessageDismissed: () => Action<State, Props>;
	setExploreSectionMessageDismissed: () => Action<State, Props>;
	loadProjectFieldsPageViewed: () => Action<State, Props>;
	setProjectFieldsPageViewed: () => Action<State, Props>;
	loadSeenPulsatingFieldsButton: () => Action<State, Props>;
	setSeenPulsatingFieldsButton: () => Action<State, Props>;
	loadProjectFieldsTourDismissed: () => Action<State, Props>;
	setProjectFieldsTourDismissed: () => Action<State, Props>;
	setProjectFieldsTourSpotlightStep: (step: ProjectFieldsTourSteps | null) => Action<State>;
	loadCollectionsTourDismissed: () => Action<State, Props, Promise<boolean | undefined>>;
	loadRoadmapIntroductionPrerequisiteDismissalsMet: () => Action<
		State,
		Props,
		Promise<boolean | undefined>
	>;
	setCollectionsTourDismissed: () => Action<State, Props>;
	setCollectionsTourSpotlightStep: (step: CollectionsTourSteps | null) => Action<State>;
	loadRoadmapIntroductionDismissed: () => Action<State, Props, Promise<boolean | undefined>>;
	setRoadmapIntroductionDismissed: () => Action<State, Props>;
	loadTimelineSectionMessageDismissed: () => Action<State, Props>;
	setTimelineSectionMessageDismissed: () => Action<State, Props>;
	loadWeeklyModeSpotlightSeen: () => Action<State, Props>;
	setWeeklyModeSpotlightSeen: () => Action<State, Props>;
	loadConnectionsSpotlightSeen: () => Action<State, Props>;
	setConnectionsSpotlightSeen: () => Action<State, Props>;
	loadCrossProjectViewFieldsDismissed: (
		viewKindStateKey: keyof typeof USER_PROPERTY_BY_STATE_KEY,
	) => Action<State, Props, Promise<boolean | undefined>>;
	setCrossProjectViewFieldsDismissed: (
		viewKindStateKey: keyof typeof USER_PROPERTY_BY_STATE_KEY,
	) => Action<State, Props>;
	loadAllViewsSpotlightDismissed: () => Action<State, Props>;
	setAllViewsSpotlightDismissed: () => Action<State, Props>;
	loadRoadmapViewSpotlightDismissed: () => Action<State, Props>;
	setRoadmapViewSpotlightDismissed: () => Action<State, Props>;
	loadRoadmapColumnConfigSpotlightDismissed: () => Action<State, Props>;
	setRoadmapColumnConfigSpotlightDismissed: () => Action<State, Props>;
	loadPrioritizationViewTourDismissed: () => Action<State, Props>;
	setPrioritizationViewTourDismissed: () => Action<State, Props>;
	setPrioritizationViewTourSpotlightStep: (
		step: PrioritizationViewTourSteps | null,
	) => Action<State>;
	loadPremiumLastVisit: (
		isPremiumEdition: boolean,
	) => Action<State, Props, Promise<boolean | undefined>>;
	loadPremiumModalDismissed: () => Action<State, Props, Promise<boolean | undefined>>;
	setPremiumLastVisit: (isPremium: boolean) => Action<State, Props>;
	setPremiumModalDismissed: () => Action<State, Props>;
	loadCustomDatesCustomizeSpotlightDismissed: () => Action<
		State,
		Props,
		Promise<boolean | undefined>
	>;
	setCustomDatesCustomizeSpotlightDismissed: () => Action<State, Props>;
	unlockOnboardingFlow: () => Action<State, Props>;
	loadImportState: () => Action<State, Props, Promise<void>>;
	setSuccessNotificationViewed: (successNotificationViewed: boolean) => Action<State, Props>;
	loadUnifiedShareDialogSpotlightState: () => Action<State, Props, Promise<void>>;
	setUnifiedShareDialogSpotlightDismissed: (spotlightDismissed: boolean) => Action<State, Props>;
	loadTreeViewOnboardingSpotlightDismissed: () => Action<State, Props>;
	setTreeViewOnboardingSpotlightDismissed: () => Action<State, Props>;
	loadCardCoverSpotlightState: () => Action<State, Props, Promise<void>>;
	setCardCoverSpotlightDismissed: (spotlightDismissed: boolean) => Action<State, Props>;
	loadGlobalViewsSectionMessageDismissed: () => Action<State, Props>;
	setGlobalViewsSectionMessageDismissed: () => Action<State, Props>;
	loadStartWithTemplateSpotlightDismissed: () => Action<State, Props>;
	setStartWithTemplateSpotlightDismissed: () => Action<State, Props>;
	loadJqlFiltersSpotlightDismissed: () => Action<State, Props>;
	setJqlFiltersSpotlightDismissed: () => Action<State, Props>;
};

export const actions: Actions = {
	loadProductUsageStartTimestamp,
	loadGoToProjectSpotlightDismissed,
	setGoToProjectSpotlightDismissed,
	setGlobalFieldsTourSpotlightStep,
	loadGlobalFieldsTourDismissed,
	setGlobalFieldsTourDismissed,
	loadExploreSectionMessageDismissed,
	setExploreSectionMessageDismissed,
	loadProjectFieldsPageViewed,
	setProjectFieldsPageViewed,
	loadSeenPulsatingFieldsButton,
	setSeenPulsatingFieldsButton,
	loadProjectFieldsTourDismissed,
	setProjectFieldsTourDismissed,
	setProjectFieldsTourSpotlightStep,
	loadCollectionsTourDismissed,
	loadRoadmapIntroductionPrerequisiteDismissalsMet,
	setCollectionsTourDismissed,
	setCollectionsTourSpotlightStep,
	loadRoadmapIntroductionDismissed,
	setRoadmapIntroductionDismissed,
	loadTimelineSectionMessageDismissed,
	setTimelineSectionMessageDismissed,
	loadWeeklyModeSpotlightSeen,
	setWeeklyModeSpotlightSeen,
	loadConnectionsSpotlightSeen,
	setConnectionsSpotlightSeen,
	loadCrossProjectViewFieldsDismissed,
	setCrossProjectViewFieldsDismissed,
	loadAllViewsSpotlightDismissed,
	setAllViewsSpotlightDismissed,
	loadRoadmapViewSpotlightDismissed,
	setRoadmapViewSpotlightDismissed,
	loadRoadmapColumnConfigSpotlightDismissed,
	setRoadmapColumnConfigSpotlightDismissed,
	loadPrioritizationViewTourDismissed,
	setPrioritizationViewTourDismissed,
	setPrioritizationViewTourSpotlightStep,
	loadPremiumLastVisit,
	loadPremiumModalDismissed,
	setPremiumLastVisit,
	setPremiumModalDismissed,
	loadCustomDatesCustomizeSpotlightDismissed,
	setCustomDatesCustomizeSpotlightDismissed,
	unlockOnboardingFlow,
	loadImportState,
	setSuccessNotificationViewed,
	loadUnifiedShareDialogSpotlightState,
	setUnifiedShareDialogSpotlightDismissed,
	loadTreeViewOnboardingSpotlightDismissed,
	setTreeViewOnboardingSpotlightDismissed,
	loadCardCoverSpotlightState,
	setCardCoverSpotlightDismissed,
	loadGlobalViewsSectionMessageDismissed,
	setGlobalViewsSectionMessageDismissed,
	loadStartWithTemplateSpotlightDismissed,
	setStartWithTemplateSpotlightDismissed,
	loadJqlFiltersSpotlightDismissed,
	setJqlFiltersSpotlightDismissed,
};
